// Runtime APIs our dependencies use that older browsers lack. esbuild only
// transpiles syntax, never polyfills built-ins, so these have to be shipped.

// `Object.hasOwn` requires Safari 15.4+. @base-ui/react's TabsRoot calls it on
// every render, which threw on iOS 14 and took down the whole /menu page.
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: (obj: object, prop: PropertyKey) =>
      Object.prototype.hasOwnProperty.call(obj, prop),
    configurable: true,
    writable: true,
  })
}
